import React, { useEffect } from 'react';
import Seo from '../components/Seo';
import Header from '../components/Header';
import FactoryHero from '../components/FactoryHero';
import ProofStrip from '../components/ProofStrip';
import OutcomesSection from '../components/OutcomesSection';
import PipelineSection from '../components/PipelineSection';
import DemoSection from '../components/DemoSection';
import Chapters from '../components/Chapters';
import VerificationSection from '../components/VerificationSection';
import DeploySection from '../components/DeploySection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

// Deep links like /#cta (the demo CTA on blog posts) land on the section, not the hero.
const useScrollToHash = () => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) document.getElementById(id)?.scrollIntoView({ block: 'start' });
  }, []);
};

const LandingPage = () => {
  useScrollToHash();
  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <Seo
        title="Emboscale: AI factory layout and robot programming software"
        description="The Factory Agent: one prompt becomes a factory, first draft in 30 minutes. AI factory layout planning, shift scheduling, line balancing, digital work instructions, and verified AI robot programming — end to end."
        path="/"
      />
      <Header />
      <FactoryHero />
      <ProofStrip />
      <OutcomesSection />
      <PipelineSection />
      <DemoSection />
      <Chapters />
      <VerificationSection />
      <DeploySection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default LandingPage;
